import React from 'react'


export const HeroInternas = ({title, title2, clase, img, imgMobile}) => {
    return (
        <div className="heroInternas">
            <img className={"heroInternas--img " + clase }  src={img} />
            <img className={"heroInternas--imgMobile " + clase } src={imgMobile} />

            <div className="heroInternas--div">
                <h1>{title}</h1>
                <h2>{title2}</h2>

            </div>

        </div>
    )
}
